var nunjucks = require("exports?nunjucks!nunjucks/browser/nunjucks-slim");
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
var env = new nunjucks.Environment([], { autoescape: true });
var configure = require("/code/nunjucks.config.js")(env);
dependencies["front/components/BtnLoad/BtnLoad.jinja"] = require( "front/components/BtnLoad/BtnLoad.jinja" );




var shim = require("/code/node_modules/nunjucks-loader/runtime-shim");
(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["ProjectList.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/BtnLoad/BtnLoad.jinja", false, "ProjectList.jinja", function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("BtnLoad", t_1);
var macro_t_4 = runtime.makeMacro(
["hasMore"], 
[], 
function (l_hasMore, kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("hasMore", l_hasMore);
var t_5 = "";t_5 += "<div class=\"ProjectList\">\n        <ul class=\"ProjectList-list\">\n            ";
t_5 += runtime.suppressValue((lineno = 5, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "caller"), "caller", context, [])), env.opts.autoescape);
t_5 += "\n        </ul>\n\n        ";
if(l_hasMore) {
t_5 += "\n            <div class=\"ProjectList-btn\">\n                ";
t_5 += runtime.suppressValue((lineno = 10, colno = 37, runtime.callWrap(runtime.memberLookup((t_1),"BtnLoad"), "BtnLoad[\"BtnLoad\"]", context, [runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
frame = frame.push();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";t_7 += runtime.suppressValue((lineno = 10, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["загрузить еще"])), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
t_5 += "\n            </div>\n        ";
;
}
t_5 += "\n    </div>";
;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
context.addExport("ProjectList");
context.setVariable("ProjectList", macro_t_4);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

var obj = nunjucks.nunjucksPrecompiled["ProjectList.jinja"]
module.exports = shim(nunjucks, env, obj, dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProjectList/ProjectList.jinja
// module id = 49
// module chunks = 0